var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(public)",
        fn: function (data) {
          return [
            data.item.plan.type.code === "membership" &&
            data.item.plan.is_free &&
            !data.item.plan.is_public &&
            _vm.hasFreePublicMembershipPlan
              ? [_vm._v("\n      No\n    ")]
              : _c(
                  "no-permission-wrapper",
                  { attrs: { show: !_vm.canUpdatePricingPlans } },
                  [
                    _c("b-form-checkbox", {
                      attrs: {
                        checked: data.item.plan.is_public,
                        disabled: !_vm.canUpdatePricingPlans,
                      },
                      on: {
                        input: (val) =>
                          _vm.updatePlanPublicStatus(data.item.plan, val),
                      },
                    }),
                  ],
                  1
                ),
          ]
        },
      },
      {
        key: "cell(type)",
        fn: function (data) {
          return [
            data.item.plan.type.code === "membership"
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Membership"),
                ])
              : data.item.plan.type.code === "add-on"
              ? _c("b-badge", { attrs: { variant: "primary" } }, [
                  _vm._v("Add-on"),
                ])
              : _c("span", [_vm._v(_vm._s(data.item.type))]),
            _vm._v(" "),
            data.item.plan.company_type.code === "metrc"
              ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                  _vm._v("THC"),
                ])
              : data.item.plan.company_type.code === "non-metrc"
              ? _c("b-badge", { attrs: { variant: "warning" } }, [
                  _vm._v("Non-THC"),
                ])
              : _c("span", [_vm._v(_vm._s(data.item.type))]),
          ]
        },
      },
      {
        key: "cell(licenses)",
        fn: function (data) {
          return [
            data.item.plan.is_limit_licenses
              ? _c("span", [_vm._v(_vm._s(data.item.plan.licenses_limit))])
              : _vm._e(),
            _vm._v(" "),
            data.item.plan.allow_extra_licenses
              ? _c("span", [
                  _vm._v(
                    "/+" +
                      _vm._s(
                        _vm.getFormattedPrice(
                          data.item.plan.extra_license_price
                        )
                      )
                  ),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(billing)",
        fn: function (data) {
          return [
            !data.item.plan.is_free
              ? [
                  data.item.plan.billing_frequency === "recurring"
                    ? [
                        _c("span", [
                          _vm._v(
                            "Recurring (" +
                              _vm._s(
                                _vm.getFormattedRecurringBilling(
                                  data.item.plan.billing_recurrence
                                )
                              ) +
                              ")"
                          ),
                        ]),
                      ]
                    : [_c("span", [_vm._v("One Time")])],
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.companyView
              ? [
                  data.item.plan.pivot.last_payment_failed_at
                    ? [
                        _c("br"),
                        _vm._v(" "),
                        _c("strong", { staticClass: "text-danger" }, [
                          _vm._v("Payment failed"),
                        ]),
                      ]
                    : data.item.plan.pivot.last_paid_amount
                    ? [
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "strong",
                          { staticClass: "text-success" },
                          [
                            data.item.plan.billing_frequency === "recurring"
                              ? [_vm._v("\n            Last Paid:\n          ")]
                              : [_vm._v("\n            Paid:\n          ")],
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.getFormattedPrice(
                                    data.item.plan.pivot.last_paid_amount
                                  )
                                )
                            ),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(free_trial)",
        fn: function (data) {
          return [
            !data.item.plan.is_free && data.item.plan.is_free_trial
              ? [
                  _c("span", [
                    _vm._v(
                      _vm._s(data.item.plan.free_trial_length) +
                        " " +
                        _vm._s(data.item.plan.free_trial_period) +
                        "s"
                    ),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(rates_by_user)",
        fn: function (data) {
          return [
            !data.item.plan.is_free
              ? [
                  _c("span", [
                    _vm._v(_vm._s(data.item.rates_by_user ? "Yes" : "No")),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(rates_by_limit)",
        fn: function (data) {
          return [
            !data.item.plan.is_free
              ? [
                  _c("span", [
                    _vm._v(_vm._s(data.item.rates_by_limit ? "Yes" : "No")),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(plan_started)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.convertFromUtc(data.item.plan.pivot.starts_at, "L")
                ) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(next_charge)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  !data.item.plan.pivot.finishes_at &&
                    data.item.plan.pivot.next_charge_at
                    ? _vm.convertFromUtc(
                        data.item.plan.pivot.next_charge_at,
                        "L"
                      )
                    : ""
                ) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(plan_ends)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  data.item.plan.pivot.finishes_at
                    ? _vm.convertFromUtc(data.item.plan.pivot.finishes_at, "L")
                    : ""
                ) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(actions)",
        fn: function (data) {
          return [
            !data.item.plan.pivot.finishes_at &&
            data.item.plan.pivot.next_charge_at
              ? _c(
                  "no-permission-wrapper",
                  { attrs: { show: !_vm.canCancelPricingPlans } },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "danger",
                          disabled: !_vm.canCancelPricingPlans,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.cancelPricingPlan(data.item.plan)
                          },
                        },
                      },
                      [_vm._v("\n        Cancel\n      ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }